export function initializeSelect(id) {
    $("#"+id).select2();
}

export function initSelectBoxesInModal(modalId, identifiers) {
    $("#modal-" + modalId).on("show.bs.modal", function () {
        setTimeout(function () {
            for (let i = 0; i < identifiers.length; i++) {
                $("#" + identifiers[i]).select2({
                    dropdownParent: $("#modal-" + modalId)
                });
            }
        }, 200)
    })
}

export function onChangeSelect2(id, dotnetHelper, nameFunc) {
    $('#' + id).on('select2:select', function () {
        dotnetHelper.invokeMethodAsync(nameFunc, $('#' + id).val());
    });
}

export function clearSelect2Box(id) {
    $("#" + id).select2('destroy');
}

/*type of parameters:
 * - NO_INPUT_SEARCH: no searchable input
 * 
 */
export function initializeSelectWithParameter(selector, parameters) {
    let startParamsForSelect2 = {};
    parameters.forEach(function (parameter) {
        if (parameter === 'NO_INPUT_SEARCH') {
            startParamsForSelect2.minimumResultsForSearch = -1
        }
        $(selector).select2(startParamsForSelect2);
    })
}

export function initFormValidation() {
    $('.needs-validation').submit(function () { $(this).addClass('was-validated') })
}

export function showModal(id, message) {
    $(`#modal-${id}`).modal('show');
    if (message != null && message != undefined) {
        $(`#modal-${id} .modal-body .dp-content .error-message`).html(message);
    }
}

export function closeModal(id) {
    $(`#modal-${id}`).modal('hide');
}